import { clone } from 'lodash-es';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';

export default {
  name: 'FcBreadcrumb',
  props: {
    icon: {
      type: String,
      default: 'FCyuanshuju',
    },
    // 不可点击面包屑
    staticBreadcrumbsList: {
      type: Array,
      default: () => [],
    },
    // 可点击面包屑
    dynamicBreadcrumbsList: {
      type: Array,
      default: () => [],
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      breadcrumbElLen: 0,
      parentElLen: 0,
      packUpBreadcrumbList: [],
      tiledBreadcrumbsList: [],
    };
  },
  created() {
    // console.log("🚀 ~ file: form-build.vue:49 ~ this.props:", this);
  },
  mounted() {},
  watch: {
    dynamicBreadcrumbsList: {
      handler(newVal) {
        this.packUpBreadcrumbList = [];
        this.tiledBreadcrumbsList = clone(newVal);
        this.$nextTick(function() {
          this.packUpBreadcrumbs();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /*
     * 点击可修改面包屑接口事件
     */
    changeBreadcrumb(bread) {
      // if(bread.to){
      //   this.$router.push({ path: bread.to, query:bread.query||{} });
      // }
      this.$emit('click', bread);
    },
    /*
     * 点击回退按钮事件
     */
    backUpBread(bread) {
      this.$emit('backUpBread', bread);
    },

    packUpBreadcrumbs() {
      // 监听元素宽度修改后 做缩放处理
      const breadcrumbElAll = document.querySelector('.fc-breadcrumb');
      const breadcrumbEl = breadcrumbElAll;
      const parentEl = (breadcrumbEl && breadcrumbEl.parentElement) || null;
      const breadcrumbElLen = (breadcrumbEl && breadcrumbEl.offsetWidth) || 0;
      const parentElLen = (parentEl && parentEl.offsetWidth) || 0;
      // 当前元素大于父节点 需要收起中间
      if (parentElLen < breadcrumbElLen && this.tiledBreadcrumbsList.length > 1) {
        this.packUpBreadcrumbList = [
          ...this.packUpBreadcrumbList,
          ...this.tiledBreadcrumbsList.splice(0, 1),
        ];
        this.$nextTick(() => {
          this.packUpBreadcrumbs();
        });
      }
    },
  },
  render() {
    const { packUpBreadcrumbList, tiledBreadcrumbsList, staticBreadcrumbsList } = this;

    const { getPrefixCls, locale } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-breadcrumb');

    return (
      <div>
        <a-breadcrumb class={prefixCls}>
          <span slot="separator" style="color: red">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.14648 10.2244L6.89968 1.4754L7.85357 1.77558L5.10037 10.5246L4.14648 10.2244Z" fill="#C9CDD4"/>
          </svg>

          </span>
          <a-breadcrumb-item>
            <fc-icon className={`${this.icon} ${prefixCls}-breadcrumbIcon`} />
          </a-breadcrumb-item>
          {staticBreadcrumbsList.map((bread, index) => (
            <a-breadcrumb-item class="static__breadcrumb" key={index}>
              {bread && bread.name}
            </a-breadcrumb-item>
          ))}
          {packUpBreadcrumbList.length > 0 && (
            <a-breadcrumb-item>
              <a>...{locale.Breadcrumb.more}...</a>
              <a-menu slot="overlay">
                {packUpBreadcrumbList.map((bread, index) => (
                  <a-menu-item key={index}>
                    <a onClick={() => this.changeBreadcrumb(bread)}>{bread && bread.name}</a>
                  </a-menu-item>
                ))}
              </a-menu>
            </a-breadcrumb-item>
          )}
          {tiledBreadcrumbsList.map((bread, index) => (
           tiledBreadcrumbsList.length-1 !== index)? (<a-breadcrumb-item class="dynamic__breadcrumb dynamic__breadcrumb_click" key={index}>
              <a onClick={() => this.changeBreadcrumb(bread)}>{bread && bread.name}</a>
            </a-breadcrumb-item>):(<a-breadcrumb-item class="static__breadcrumb static__breadcrumb__current" key={index}>
            {bread && bread.name}
          </a-breadcrumb-item>)
          )}
        </a-breadcrumb>
      </div>
    );
  },
};
